//PACKS
import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";

//COMPONENTS
import ProductInfoDesktop from "./ProductInfoDesktop";

//STYLES
import "../styles/productDesktop.scss";

export default function ProductDesktop(props) {
  //STATE
  const [toggle, setToggle] = useState(false);

  //ON TOGGLE
  useEffect(() => {
    let bg = toggle ? props.product.picture : null;
    props.handleBackgroundImage(bg);
    props.handleCurrentSlide(props.index);
    // console.log("clicked on", props.index);
    // console.log("selected", props.currentSlide);
  }, [toggle]);

  //UNTOGGLE IN NOT CURRENT SLIDE
  useEffect(() => {
    if (props.currentSlide !== props.index) {
      setToggle(false);
    }
  }, [props]);

  //ANIMATIONS
  const productContainerPicToggle = useSpring({
    width: toggle ? "936px" : "216px",
  });
  const productContainerToggle = useSpring({
    zIndex: toggle ? 10 : 1,
    position: toggle ? "absolute" : "relative",
  });
  const productPicToggle = useSpring({
    opacity: toggle ? "0" : "1",
    height: "100%",
  });

  return (
    <animated.div
      style={productContainerToggle}
      className="productContainerDesktop"
    >
      <animated.div
        style={productContainerPicToggle}
        className="productDesktop"
        onClick={() => {
          setToggle(!toggle);
        }}
      >
        {toggle ? <ProductInfoDesktop product={props.product} /> : <></>}
        <animated.img style={productPicToggle} src={props.product.picture} />
      </animated.div>
    </animated.div>
  );
}
